import { get } from 'lodash'
import { mapState } from 'vuex'
import { loadStripe } from '@stripe/stripe-js'
import { customerPortal, checkoutSession } from '@/lib/api.js'

export default {
  data: () => ({
    stripe: null,
  }),
  async mounted() {
    this.stripe = await loadStripe(process.env.VUE_APP_ACCOUNT_STRIPE_PUBLIC_KEY)
  },
  computed: {
    ...mapState(['user', 'firebaseUser']),
    hasPlan() {
      return (
        ['PLAN_PREMIUM', 'PLAN_PRO', 'PLAN_UNLIMITED', 'PLAN_CUSTOM'].indexOf(this.user.status) > -1
      )
    },
    userAccountStripeSubscription() {
      return get(this.user.account, 'stripe.subscription', null)
    },
  },
  methods: {
    async goToCustomerPortal() {
      if (this.loading) return
      if (!this.hasPlan && get(this.userAccountStripeSubscription, 'status', null) !== 'incomplete')
        return

      this.loading = true
      const result = await customerPortal()
      const sessionUrl = result.data.sessionUrl
      window.location = sessionUrl
      // NOT LOADING = FALSE -> para dar la impresion de que carga hasta que hace el window.location
    },
    async subscriptionCheckout({ plan, isMonthly }) {
      if (this.loading) return
      if (
        ['PLAN_PREMIUM', 'PLAN_PRO', 'PLAN_UNLIMITED', 'PLAN_CUSTOM'].indexOf(this.user.status) > -1
      )
        return

      this.loading = true
      const result = await checkoutSession({ plan, isMonthly })
      const sessionId = result.data.sessionId
      await this.stripe.redirectToCheckout({ sessionId })
      // NOT LOADING = FALSE -> para dar la impresion de que carga hasta que hace el window.location
    },
  },
}
